import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Lock, ShieldCheck, CheckCircle2, ChevronDown, Gift } from 'lucide-react';
export function PricingCTA() {
  const [expandedBonus, setExpandedBonus] = useState<number | null>(null);
  const toggleBonus = (index: number) => {
    setExpandedBonus(expandedBonus === index ? null : index);
  };
  const bonuses = [{
    id: 1,
    title: 'Bono #1: Kit Express de Ingreso Extra',
    titlePrefix: 'Bono #1:',
    titleSuffix: ' Kit Express de Ingreso Extra',
    value: '$97',
    image: 'https://cdn.magicpatterns.com/uploads/6qGFvZiDL5k1ok5WKXbhDm/bonus1_(2).png',
    desc: 'Te deja el Día 1 hecho en minutos. Incluye oferta, post y mensajes listos.',
    includes: ['Oferta en 1 frase', 'Post listo', 'Mensajes de cierre', 'Checklist Día 1']
  }, {
    id: 2,
    title: 'Bono #2: Respuestas que Cierran',
    titlePrefix: 'Bono #2:',
    titleSuffix: ' Respuestas que Cierran',
    value: '$52',
    image: 'https://cdn.magicpatterns.com/uploads/uTJfFq1Xp8sEeWAeRgsgdo/bonus_2.png',
    desc: 'Palabras exactas para responder objeciones sin quedarte en blanco.',
    includes: ['Mensajes copiar/pegar', 'Respuestas a "está caro"', 'Manejo de "lo voy a pensar"']
  }];
  return <section id="pricing" className="py-20 px-4 bg-gradient-to-b from-brand-bg to-[#0a0a0a]" data-id="element-213">
      <div className="max-w-3xl mx-auto text-center" data-id="element-214">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-surface border-2 border-brand-yellow rounded-2xl p-8 md:p-12 shadow-[0_0_50px_rgba(234,179,8,0.15)] relative overflow-hidden" data-id="element-215">
          {/* Badge */}
          <div className="absolute top-0 right-0 bg-brand-yellow text-black font-bold text-xs uppercase px-3 py-1 rounded-bl-lg" data-id="element-216">
            Oferta Limitada
          </div>

          <h2 className="font-display text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-217">
            Empieza Tu Plan de 7 Días
          </h2>
          <p className="text-gray-400 mb-8 max-w-lg mx-auto" data-id="element-218">
            Si este Libro Digital te evita perder 3 semanas "pensando" y te
            ayuda a conseguir 1 solo cliente, ya se pagó solo.
          </p>

          <div className="flex items-center justify-center gap-4 mb-8" data-id="element-219">
            <span className="text-gray-500 line-through text-2xl" data-id="element-220">$97</span>
            <span className="text-6xl font-display font-bold text-brand-yellow" data-id="element-221">
              $7.89
            </span>
            <span className="text-gray-400 text-xl self-end mb-2" data-id="element-222">USD</span>
          </div>

          {/* What's Included Box */}
          <div className="bg-[#0a0a0a] rounded-xl p-5 mb-8 border border-gray-800 text-left max-w-md mx-auto" data-id="element-223">
            <p className="text-xs uppercase tracking-widest text-brand-yellow font-bold mb-3" data-id="element-224">
              Incluye:
            </p>
            <ul className="space-y-2.5" data-id="element-225">
              {['El Método Mapa 3×3 con 9 rutas listas', 'Plantillas de publicación para copiar y pegar', 'Guiones de venta y manejo de objeciones', 'Plan diario paso a paso por 7 días'].map((item, i) => <li key={i} className="flex items-start gap-2.5 text-sm text-gray-300" data-id="element-226">
                  <CheckCircle2 className="text-brand-yellow shrink-0 mt-0.5" size={16} data-id="element-227" />
                  <span data-id="element-228">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Compact Bonus Summary */}
          <div className="max-w-md mx-auto mb-8" data-id="element-229">
            <div className="flex items-center gap-2 mb-4 justify-center" data-id="element-230">
              <Gift size={16} className="text-brand-yellow" data-id="element-231" />
              <h3 className="text-sm font-bold text-white uppercase tracking-wide" data-id="element-232">
                Bonos incluidos GRATIS{' '}
                <span className="text-green-400 font-normal normal-case" data-id="element-233">
                  (Valor: $149 USD)
                </span>
              </h3>
            </div>

            <div className="space-y-3" data-id="element-234">
              {bonuses.map((bonus, index) => <div key={bonus.id} className="bg-[#0a0a0a] border border-gray-800 rounded-lg overflow-hidden" data-id="element-235">
                  <div className="p-3 flex gap-3 items-start" data-id="element-236">
                    {/* Thumbnail */}
                    <div className="w-12 h-16 bg-[#1a1a1a] rounded flex-shrink-0 overflow-hidden border border-gray-800" data-id="element-237">
                      <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-238" />
                    </div>

                    {/* Info */}
                    <div className="flex-1 min-w-0 text-left" data-id="element-239">
                      <div className="flex justify-between items-start" data-id="element-240">
                        <h4 className="text-sm font-bold text-white leading-tight mb-1 pr-2" data-id="element-241">
                          <span className="text-brand-yellow" data-id="element-242">
                            {bonus.titlePrefix}
                          </span>
                          {bonus.titleSuffix}
                        </h4>
                        <div className="flex flex-col items-end shrink-0" data-id="element-243">
                          <span className="text-[10px] text-gray-500 line-through" data-id="element-244">
                            {bonus.value}
                          </span>
                          <span className="text-[10px] font-bold text-brand-yellow bg-brand-yellow/10 px-1.5 rounded" data-id="element-245">
                            GRATIS
                          </span>
                        </div>
                      </div>
                      <p className="text-xs text-gray-400 line-clamp-1 mb-1.5" data-id="element-246">
                        {bonus.desc}
                      </p>

                      <button onClick={() => toggleBonus(index)} className="text-xs text-brand-yellow hover:text-white transition-colors flex items-center gap-1 font-medium" data-id="element-247">
                        Leer más
                        <ChevronDown size={12} className={`transition-transform duration-300 ${expandedBonus === index ? 'rotate-180' : ''}`} data-id="element-248" />
                      </button>
                    </div>
                  </div>

                  {/* Expanded Content */}
                  <AnimatePresence data-id="element-249">
                    {expandedBonus === index && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.2
                }} className="overflow-hidden bg-[#111] border-t border-gray-800" data-id="element-250">
                        <div className="p-4 text-left" data-id="element-251">
                          <div className="flex justify-center mb-4" data-id="element-252">
                            <img src={bonus.image} alt={bonus.title} className="h-32 object-contain shadow-lg" data-id="element-253" />
                          </div>
                          <p className="text-sm text-gray-300 mb-3" data-id="element-254">
                            {bonus.desc}
                          </p>
                          <ul className="space-y-1.5" data-id="element-255">
                            {bonus.includes.map((item, i) => <li key={i} className="flex items-start gap-2 text-xs text-gray-400" data-id="element-256">
                                <CheckCircle2 size={12} className="text-brand-yellow shrink-0 mt-0.5" data-id="element-257" />
                                <span data-id="element-258">{item}</span>
                              </li>)}
                          </ul>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>)}
            </div>
          </div>

          <a href="https://www.mellowreset.com/cart/42978888450114:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (typeof window.fbq === 'function') {
            window.fbq('track', 'InitiateCheckout');
          }
        }} className="w-full md:w-auto bg-brand-yellow hover:bg-brand-yellowHover text-black font-display font-bold text-2xl uppercase py-5 px-10 rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-3 mx-auto mb-6" data-id="element-259">
            Descargar Ahora
            <ArrowRight className="w-6 h-6" strokeWidth={3} data-id="element-260" />
          </a>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-gray-500" data-id="element-261">
            <div className="flex items-center gap-2" data-id="element-262">
              <Lock size={14} data-id="element-263" /> Pago Seguro 256-bit SSL
            </div>
            <div className="hidden md:block" data-id="element-264">•</div>
            <div className="flex items-center gap-2" data-id="element-265">
              <ShieldCheck size={14} data-id="element-266" /> Garantía de Calidad
            </div>
            <div className="hidden md:block" data-id="element-267">•</div>
            <div data-id="element-268">Acceso Inmediato</div>
          </div>
        </motion.div>

        <div className="mt-12 text-gray-500 text-sm max-w-xl mx-auto" data-id="element-269">
          <p className="mb-4" data-id="element-270">
            Este producto no garantiza ingresos específicos. Los resultados
            dependen de tu ejecución. No estamos afiliados con Facebook,
            Instagram o WhatsApp.
          </p>
          <p data-id="element-271">
            © {new Date().getFullYear()} Tu Primer Ingreso Extra. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </section>;
}